import {Environments, Planars} from '../enums';

export function toMonsterEnvironments(environments: string[]) {
	return environments
		.map((environment) => {
			let base = environment;
			let plans: string[] = [];
			if (environment.startsWith('planar')) {
				[base, ...plans] = environment.split(', ');
			}

			let result = Environments[base] || base;
			if (plans && plans?.length) {
				const plansResult = plans.map((plan) => Planars[plan] || plan);
				result += ` (${plansResult.sort().join(', ')})`;
			}

			return result;
		})
		.sort()
		.join(', ');
}
